exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdpTable {\n  font-size: 10px;\n}\n.vdpClearInput{\n  display: none;\n}\n.vdpComponent, .vdpComponent .form-control{\n  height: 40px !important;\n}\n\n", ""]);

// exports
